/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Represents a floating-point valued time series point.
 * @export
 * @interface TimeSeriesPoint
 */
export interface TimeSeriesPoint {
    /**
     * Timestamp, in milliseconds since Unix epoch, of the end point of the time window covered by this time series point.
     * @type {number}
     * @memberof TimeSeriesPoint
     */
    timestamp?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSeriesPoint
     */
    value?: number;
}

/**
 * Check if a given object implements the TimeSeriesPoint interface.
 */
export function instanceOfTimeSeriesPoint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TimeSeriesPointFromJSON(json: any): TimeSeriesPoint {
    return TimeSeriesPointFromJSONTyped(json, false);
}

export function TimeSeriesPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeSeriesPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function TimeSeriesPointToJSON(value?: TimeSeriesPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'value': value.value,
    };
}

